import { useState, useEffect, useCallback } from "react";
var Seconds;
(function (Seconds) {
    Seconds[Seconds["Sixty"] = 60] = "Sixty";
    Seconds[Seconds["One"] = 1] = "One";
})(Seconds || (Seconds = {}));
export const CountdownTimer = ({ onComplete }) => {
    const [seconds, setSeconds] = useState(Seconds.Sixty);
    const [isTimerActive, setIsTimerActive] = useState(false);
    const startCountdown = useCallback(() => {
        setSeconds(Seconds.Sixty);
        setIsTimerActive(true);
    }, []);
    const resetCountdown = useCallback(() => {
        setIsTimerActive(false);
        setSeconds(Seconds.Sixty);
    }, []);
    const formatTime = (timeInSeconds) => {
        const minutes = Math.floor(timeInSeconds / Seconds.Sixty);
        const seconds = timeInSeconds % Seconds.Sixty;
        return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };
    useEffect(() => {
        let interval;
        if (isTimerActive && seconds > 0) {
            interval = window.setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            setIsTimerActive(false);
            onComplete?.();
        }
        return () => {
            if (interval) {
                window.clearInterval(interval);
            }
        };
    }, [isTimerActive, seconds, onComplete]);
    return {
        seconds,
        formattedTime: formatTime(seconds),
        startCountdown,
        resetCountdown,
        isTimerActive,
    };
};
//# sourceMappingURL=CountdownTimer.js.map